export enum AssignmentSubmissionPersonTag {
  CREATOR = 'CREATOR',
  REVIEWER = 'REVIEWER',
}
